import { BigNumber, ethers } from 'ethers';
import fetch from 'node-fetch';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const gasStation = /* @__PURE__ */ __name((gasStationUrl) => async () => {
  try {
    if (!gasStationUrl) return void 0;
    const res = await fetch(gasStationUrl);
    const data = await res.json();
    return {
      maxPriorityFeePerGas: safeParseUnits(data.standard.maxPriorityFee.toString(), 9),
      maxFeePerGas: safeParseUnits(data.standard.maxFee.toString(), 9)
    };
  } catch {
    throw new Error("Failed to fetch gas station");
  }
}, "gasStation");
const safeParseUnits = /* @__PURE__ */ __name((_value, decimals) => {
  const value = String(_value);
  if (!value.match(/^[0-9.]+$/)) {
    throw new Error(`invalid gwei value: ${_value}`);
  }
  const comps = value.split(".");
  if (comps.length === 1) {
    comps.push("");
  }
  if (comps.length !== 2) {
    throw new Error(`invalid gwei value: ${_value}`);
  }
  while (comps[1].length < decimals) {
    comps[1] += "0";
  }
  if (comps[1].length > 9 && !comps[1].substring(9).match(/^0+$/)) {
    comps[1] = BigNumber.from(comps[1].substring(0, 9)).add(BigNumber.from(1)).toString();
  }
  return ethers.utils.parseUnits(`${comps[0]}.${comps[1]}`, decimals);
}, "safeParseUnits");
const scaleBigNumber = /* @__PURE__ */ __name((wei, multiplier, precision = 2) => {
  if (wei === null || typeof wei === "undefined") {
    throw new Error("Wei not specified");
  }
  const padding = Math.pow(10, precision);
  const newMultiplier = Math.round(padding * multiplier);
  const newWei = wei.mul(newMultiplier).div(padding);
  return newWei;
}, "scaleBigNumber");
const calculateMaxFee = /* @__PURE__ */ __name((maxFee, priorityFee, scale) => {
  if (maxFee === null || typeof maxFee === "undefined") {
    throw new Error("Max Fee not specified");
  }
  if (priorityFee === null || typeof priorityFee === "undefined") {
    throw new Error("Priority Fee not specified");
  }
  if (scale === 1) {
    return maxFee;
  }
  const priorityFeeChange = scaleBigNumber(priorityFee, scale).sub(priorityFee);
  return maxFee.add(priorityFeeChange);
}, "calculateMaxFee");

export { calculateMaxFee, gasStation, scaleBigNumber };
